import classnames from 'classnames';
import React from 'react';
import styles from './close-button.scss';
import CloseTickIcon from '../../icons/compiled/components/CloseTickIcon';
import { InlineIcon } from '../inline-icon/inline-icon';
export const CloseButton = _ref => {
  let {
    className,
    ariaLabel,
    dataHook,
    theme = 'light',
    onClick
  } = _ref;
  return /*#__PURE__*/React.createElement("button", {
    onClick: onClick,
    className: classnames(styles[theme], className),
    tabIndex: 0,
    "aria-label": ariaLabel,
    "data-hook": dataHook
  }, /*#__PURE__*/React.createElement(InlineIcon, {
    icon: /*#__PURE__*/React.createElement(CloseTickIcon, null),
    className: styles.icon
  }));
};
//# sourceMappingURL=close-button.js.map